import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { PageCarousel } from './components/PageCarousel';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { shortTestimonials, moreTestimonials, coachProfiles } from './data/testimonials';
// Review sections render only once data/testimonials.ts holds real buyer reviews.

export function App() {
  return <div className="min-h-screen w-full bg-cloud text-ink font-sans selection:bg-amber selection:text-ink" data-id="element-0" data-mp="3ihuyy5jpw5en">
      <MetaPixel data-id="element-1" data-mp="3mj6lu3b7icj5" />
      <main data-id="element-2" data-mp="3rcj2nr9n9f1c">
        <Hero data-id="element-3" data-mp="3rbzomln47asl" />
        <SocialProofBar data-id="element-4" data-mp="3rdkhm6ts6loc" />
        <PainGrid data-id="element-5" data-mp="3rd189ei755lx" />
        <ProductReveal data-id="element-6" data-mp="3relwkmdx3sbc" />
        <Tomes data-id="element-7" data-mp="6hovayao7c0" />
        <PageCarousel data-id="element-8" data-mp="4wupmfw6qeo" />
        <Bonuses data-id="element-9" data-mp="5gbv0xpxarn" />
        <ValueStack data-id="element-10" data-mp="82ovg3doih9" />
        <Urgency data-id="element-11" data-mp="2zld0z6e9z99y" />
        <Pricing data-id="element-12" data-mp="2zlv66six0xu0" />
        <Testimonials testimonials={shortTestimonials} profiles={coachProfiles} background="white" data-id="element-13" data-mp="2zmepackaxs9m" />
        <Guarantee data-id="element-14" data-mp="33ngee0ki8nxv" />
        <Faq data-id="element-15" data-mp="33mykvbp88ntn" />
        <Testimonials testimonials={moreTestimonials} title="Works alongside your gym’s program" subtitle="Coaches use it to turn the skills they already teach into a full class." background="cream" data-id="element-16" data-mp="33oi3h8ycvayl" />
        <CostOfInaction data-id="element-17" data-mp="nuhged3fk1rn" />
        <Close data-id="element-18" data-mp="nv1284w7baay" />
      </main>
      <Footer data-id="element-19" data-mp="nxx0jubyo0zx" />
    </div>;
}